import React from 'react';

import { injectIntl } from 'react-intl';

import messages from './Address.messages';
import { countryOptions } from './constants';
import FormField from '../../components/FormField';

class CountrySelect extends React.Component {
    updateCountryValue = (selectedOption) => {
        const { countryField, onCountrySelect } = this.props;
        const country = selectedOption.value;

        countryField.onChange(country);
        if (country) {
            onCountrySelect(country);
        }
    };

    render() {
        const { intl, countryField } = this.props;

        return (
            <FormField.Select
                className="country-select"
                onChange={this.updateCountryValue}
                value={countryField.value}
                options={countryOptions}
                placeholder={intl.formatMessage({ ...messages.chooseCountry })}
            />
        );
    }
}

export default injectIntl(CountrySelect);
